<div class="dialog-container" [ngClass]="{ hidden: hide }">
  <div class="popup-loader-container" *ngIf="loading">
    <div
      class="inner-container uk-flex uk-flex-nowrap uk-flex-center uk-flex-middle"
    >
      <img src="/assets/images/loader.gif" alt="" />
    </div>
  </div>
  <div class="header">
    <p class="white inline-block">
      <b
        *ngIf="
          !model &&
          !editing &&
          !editPersonalSpouse &&
          !editWillExecutor &&
          !editTrustee
        "
        >Add Contact</b
      >
      <b *ngIf="!model && !editing && editPersonalSpouse">Add Spouse</b>
      <b *ngIf="!model && !editing && editWillExecutor">Add Executor</b>
      <b *ngIf="!model && !editing && editTrustee">Add Trustee</b>
      <b *ngIf="model && !editing">{{ model.first_name }}</b>
      <b *ngIf="editing">Editing {{ model.first_name }}</b>
    </p>
    <div class="inline-block float-right">
      <button
        class="uk-button uk-button-nobutton"
        *ngIf="
          !editing &&
          model &&
          [UserTypeEnum.USER, UserTypeEnum.ADMIN].includes(usertype)
        "
        (click)="edit()"
      >
        <i class="fas fa-edit"></i>
      </button>
      <button
        class="uk-button uk-button-nobutton"
        *ngIf="(editing && !saving) || addModal"
        type="submit"
        form="add-contact-form"
      >
        <i class="fas fa-save"></i>
      </button>
      <button
        class="uk-button uk-button-nobutton"
        *ngIf="editing"
        (click)="destroy()"
      >
        <i class="fas fa-trash"></i>
      </button>
      <button class="uk-button uk-button-nobutton" (click)="closeDialog()">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
  <div class="content" [ngClass]="{ 'edit-normal-view': model }">
    <div *ngIf="data && data.breadcrumbs" class="generic-breadcrumbs-component">
      <span>
        {{ data.breadcrumbs }}
      </span>
      <span>
        <i class="fas fa-chevron-right"></i>
      </span>
      <span> Add Contact </span>
    </div>
    <form
      [formGroup]="form"
      (ngSubmit)="saveContact()"
      ngNativeValidate
      id="add-contact-form"
    >
      <div
        class="input-containers margin-top-10"
        [ngClass]="{ editing: editing }"
      >
        <div
          class="error"
          *ngIf="
            [UserTypeEnum.USER, UserTypeEnum.ADMIN].includes(usertype) &&
            model &&
            model.status !== ContactEnum.STATUS_ACTIVE &&
            [ContactEnum.TYPE_DESIGNEE].includes(model.type)
          "
        >
          <span>Waiting on Acceptance.</span>
          <div class="margin-top-10">
            <button
              type="button"
              class="uk-button uk-button-white uk-button-thin"
              (click)="resendInvitation()"
              [disabled]="loading"
            >
              Resend Invitation
            </button>
          </div>
        </div>
        <div class="inputs">
          <div class="input-container">
            <input
              type="text"
              (keydown)="checkAndSetClass($event)"
              formControlName="first_name"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              [ngClass]="{
                'invalid-input-validation':
                  form.controls.first_name.touched &&
                  form.controls.first_name.invalid
              }"
              required
              [readonly]="!(editing || addModal)"
            />
            <div class="label grey">First name*</div>
            <div
              *ngIf="
                form.controls.first_name.touched &&
                form.controls.first_name.invalid
              "
              class="error"
            >
              <div *ngIf="form.controls.first_name.errors.required">
                {{ errorManager.ERRORS.firstname_required }}
              </div>
              <div *ngIf="form.controls.first_name.errors.minlength">
                {{ errorManager.ERRORS.min_2_char_required }}
              </div>
            </div>
          </div>
          <div class="input-container">
            <input
              type="text"
              (keydown)="checkAndSetClass($event)"
              formControlName="middle_name"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              [readonly]="!(editing || addModal)"
            />
            <div class="label grey">Middle name</div>
          </div>
          <div class="input-container">
            <input
              type="text"
              (keydown)="checkAndSetClass($event)"
              formControlName="last_name"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              [ngClass]="{
                'invalid-input-validation':
                  form.controls.last_name.touched &&
                  form.controls.last_name.invalid
              }"
              required
              [readonly]="!(editing || addModal)"
            />
            <div class="label grey">Last name*</div>
            <div
              *ngIf="
                form.controls.last_name.touched &&
                form.controls.last_name.invalid
              "
              class="error"
            >
              <div *ngIf="form.controls.last_name.errors.required">
                {{ errorManager.ERRORS.lastname_required }}
              </div>
              <div *ngIf="form.controls.last_name.errors.minlength">
                {{ errorManager.ERRORS.min_2_char_required }}
              </div>
            </div>
          </div>
          <div class="input-container">
            <input
              type="text"
              (keydown)="checkAndSetClass($event)"
              formControlName="email"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              [ngClass]="{
                'invalid-input-validation':
                  form.controls.email.touched && form.controls.email.invalid
              }"
              [readonly]="!(editing || addModal)"
              appEmailValidator
            />
            <div class="label grey">
              Email<span
                *ngIf="
                  form.controls.type.value !== ContactEnum.TYPE_NONE ||
                  form.controls.notifyOnDeath.value
                "
                >*</span
              >
            </div>
            <div
              *ngIf="form.controls.email.touched && form.controls.email.invalid"
              class="error"
            >
              <div *ngIf="form.controls.email.errors.required">
                {{ errorManager.ERRORS.email_required }}
              </div>
              <div *ngIf="form.controls.email.errors.email">
                {{ errorManager.ERRORS.enter_valid_email }}
              </div>
            </div>
          </div>
          <div class="input-container">
            <input
              type="text"
              (keydown)="checkAndSetClass($event)"
              formControlName="phone"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              [ngClass]="{
                'invalid-input-validation':
                  form.controls.phone.touched && form.controls.phone.invalid
              }"
              mask="(000) 000-0000"
              maxlength="14"
              minlength="10"
              [readonly]="!(editing || addModal) || phoneChangeRequested"
            />
            <div class="label grey">
              Mobile phone<span *ngIf="form.controls.type.value !== 'none'"
                >*</span
              >
            </div>
            <div *ngIf="phoneChangeRequested && editing" class="error">
              <div>
                {{ errorManager.ERRORS.phone_change_requested }}
              </div>
            </div>
            <div
              *ngIf="form.controls.phone.touched && form.controls.phone.invalid"
              class="error"
            >
              <div *ngIf="form.controls.phone.errors.required">
                {{ errorManager.ERRORS.phone_required }}
              </div>
              <div *ngIf="form.controls.phone.errors.minlength">
                {{ errorManager.ERRORS.phone_number_digit }}
              </div>
              <div *ngIf="form.controls.phone.errors.maxlength">
                {{ errorManager.ERRORS.phone_number_digit }}
              </div>
            </div>
          </div>
          <div class="input-container">
            <input
              type="text"
              (keydown)="checkAndSetClass($event)"
              formControlName="workPhone"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              mask="(000) 000-0000"
              maxlength="14"
              minlength="10"
              [readonly]="!(editing || addModal)"
            />
            <div class="label grey">Work phone</div>
            <div
              *ngIf="
                form.controls.workPhone.touched &&
                form.controls.workPhone.invalid
              "
              class="error"
            >
              <div *ngIf="form.controls.workPhone.errors.minlength">
                {{ errorManager.ERRORS.phone_number_digit }}
              </div>
              <div *ngIf="form.controls.workPhone.errors.maxlength">
                {{ errorManager.ERRORS.phone_number_digit }}
              </div>
            </div>
          </div>

          <div class="input-container checkbox-container">
            <div
              class="selection-circle"
              (click)="
                form.controls.notifyOnDeath.setValue(
                  !form.controls.notifyOnDeath.value
                )
              "
              [ngClass]="{ selected: form.controls.notifyOnDeath.value }"
            >
              <div class="outer-cirlce">
                <div class="inner-circle"></div>
              </div>
            </div>
            <label><b>Notify them upon my passing</b></label>
          </div>

          <div
            class="input-container"
            [ngClass]="{
              inputted: editPersonalSpouse || editWillExecutor || editTrustee
            }"
          >
            <app-viewonly-select-mode
              [options]="relationshipOptions"
              [value]="form.controls.relationship.value"
              keyname="id"
              valuename="name"
            >
            </app-viewonly-select-mode>
            <select
              name="relationship"
              formControlName="relationship"
              id=""
              (keydown)="checkAndSetClass($event)"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              readonly
            >
              <option
                *ngFor="
                  let relationshipOption of relationshipOptions;
                  let i = index
                "
                [value]="relationshipOptions[i].id"
              >
                {{ relationshipOptions[i].name }}
              </option>
            </select>
            <div class="label grey">Relationship</div>
          </div>
          <div
            *ngIf="[UserTypeEnum.USER, UserTypeEnum.ADMIN].includes(usertype)"
            class="input-container"
          >
            <span *ngIf="actsToDisplay" class="label-normal"
              ><span class="font-14">Acting As:</span> {{ actsToDisplay }}</span
            >
            <div
              *ngIf="form.controls.type.value === 'none'"
              class="label-normal"
            >
              <small>* Use Role to make them an Information Designee</small>
            </div>
          </div>
          <div
            *ngIf="[UserTypeEnum.USER, UserTypeEnum.ADMIN].includes(usertype)"
            class="input-container"
            [ngClass]="{
              inputted:
                editPersonalSpouse ||
                editWillExecutor ||
                editTrustee ||
                editBeneficiary
            }"
          >
            <app-viewonly-select-mode
              [options]="typeOptions"
              [value]="form.controls.type.value"
              keyname="id"
              valuename="name"
            >
            </app-viewonly-select-mode>
            <select
              name="type"
              formControlName="type"
              (keydown)="checkAndSetClass($event)"
              (change)="checkAndSetClass($event)"
              (focus)="checkAndSetClass($event)"
              (input)="checkAndSetClass($event)"
              (blur)="checkAndSetClass($event)"
              [ngClass]="{
                'invalid-input-validation':
                  form.controls.type.touched && form.controls.type.invalid
              }"
              required
            >
              <option
                *ngFor="let typeOption of typeOptions; let j = index"
                [value]="typeOptions[j].id"
              >
                {{ typeOptions[j].name }}
              </option>
            </select>
            <div class="label grey">Role*</div>
            <div
              *ngIf="form.controls.type.touched && form.controls.type.invalid"
              class="error"
            >
              <div *ngIf="form.controls.type.errors.required">
                {{ errorManager.ERRORS.role_required }}
              </div>
            </div>
          </div>
          <div
            *ngIf="!address && !editPersonalSpouse"
            class="add-address-container address-container"
          >
            <div *ngIf="!model || editing" class="adding-button-inside">
              <button
                class="uk-button uk-button-nobutton add-button"
                (click)="addAddress()"
                type="button"
              >
                <i class="fas fa-plus"></i> Add new address
              </button>
            </div>
            <div class="address-container" *ngIf="model && !editing">
              <br />
              <b>No Address</b><br />
            </div>
          </div>
          <div
            *ngIf="address && !editPersonalSpouse"
            class="add-address-container"
          >
            <div *ngIf="!model || editing" class="adding-button-inside">
              <button
                class="uk-button uk-button-nobutton add-button"
                (click)="editAddress()"
                type="button"
              >
                <i class="fas fa-plus"></i> Update address
              </button>
            </div>
            <div class="address-container">
              <b>Current Address</b><br />
              {{ address.address_1 }} <br />
              {{ address.city }}, {{ address.state }} {{ address.zip }}
              <div
                class="delete-button"
                (click)="deleteAddressWithConfirmation()"
                *ngIf="!model || editing"
              >
                <i class="fas fa-times pointer"></i>
              </div>
            </div>
          </div>
          <div
            *ngIf="
              [UserTypeEnum.USER, UserTypeEnum.ADMIN].includes(usertype) &&
              form.controls.type.value === ContactEnum.TYPE_DESIGNEE &&
              !isInSignUp
            "
          >
            <div
              class="input-container access-control"
              [ngClass]="{
                disable: (model && !editing) || usertype === UserTypeEnum.ADMIN
              }"
            >
              <div class="label-normal">Information Designee Access</div>
              <div class="designee-access-type">
                <div
                  *ngIf="(model && !editing) || usertype === UserTypeEnum.ADMIN"
                >
                  <div
                    class="checkbox-container"
                    *ngIf="form.controls.allowAllItems.value"
                  >
                    <label>Allowed access to all items</label>
                  </div>
                  <div
                    class="checkbox-container"
                    *ngIf="!form.controls.allowAllItems.value"
                  >
                    <label>Selected access for individual items</label>
                  </div>
                </div>
                <div
                  *ngIf="
                    !((model && !editing) || usertype === UserTypeEnum.ADMIN)
                  "
                >
                  <div
                    class="checkbox-container"
                    (click)="form.controls.allowAllItems.setValue(true)"
                  >
                    <div
                      class="selection-circle"
                      [ngClass]="{
                        selected: form.controls.allowAllItems.value
                      }"
                    >
                      <div class="outer-cirlce">
                        <div class="inner-circle"></div>
                      </div>
                    </div>
                    <label>Allow access to all items</label>
                  </div>
                  <div
                    class="checkbox-container"
                    (click)="form.controls.allowAllItems.setValue(false)"
                  >
                    <div
                      class="selection-circle"
                      [ngClass]="{
                        selected: !form.controls.allowAllItems.value
                      }"
                    >
                      <div class="outer-cirlce">
                        <div class="inner-circle"></div>
                      </div>
                    </div>
                    <label>Select access for individual items</label>
                  </div>
                </div>
              </div>
              <div
                class="user-permission-list"
                *ngIf="!form.controls.allowAllItems.value"
              >
                <app-access-control-card-list
                  name="Banks"
                  label="institutionCompanyName"
                  [cardList]="bankAccounts"
                  [permissionList]="cardsPermissionsForModel.bankAccounts"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Real Estates"
                  label="label"
                  [cardList]="realEstates"
                  [permissionList]="cardsPermissionsForModel.realEstates"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Login Accounts And Devices"
                  label="label"
                  [cardList]="loginAccounts"
                  [permissionList]="cardsPermissionsForModel.loginAccounts"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Trusts"
                  label="label"
                  [cardList]="trust"
                  [permissionList]="cardsPermissionsForModel.trust"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Insurance"
                  label="label"
                  [cardList]="insurances"
                  [permissionList]="cardsPermissionsForModel.insurances"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Investments"
                  label="label"
                  [cardList]="investments"
                  [permissionList]="cardsPermissionsForModel.investments"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Multimedia"
                  label="label"
                  [cardList]="multimedias"
                  [permissionList]="cardsPermissionsForModel.multimedias"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Additional Docs"
                  label="label"
                  [cardList]="additionalDocs"
                  [permissionList]="cardsPermissionsForModel.additionalDocs"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Will"
                  label="dateSigned"
                  [cardList]="wills"
                  [permissionList]="cardsPermissionsForModel.wills"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Retirement Accounts"
                  label="label"
                  [cardList]="retirementAccounts"
                  [permissionList]="cardsPermissionsForModel.retirementAccounts"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Tax Information Accountants"
                  label="label"
                  [cardList]="taxAccountants"
                  [permissionList]="cardsPermissionsForModel.taxAccountants"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Tax Return"
                  label="label"
                  [cardList]="taxReturn"
                  [permissionList]="cardsPermissionsForModel.taxReturn"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Tax Documentation"
                  label="label"
                  [cardList]="taxDocumentation"
                  [permissionList]="cardsPermissionsForModel.taxDocumentation"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Tax Basis"
                  label="label"
                  [cardList]="taxBasis"
                  [permissionList]="cardsPermissionsForModel.taxBasis"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>

                <app-access-control-card-list
                  name="Copies of Identification"
                  label="label"
                  [cardList]="identification"
                  [permissionList]="cardsPermissionsForModel.identification"
                  [editing]="
                    !(model && !editing) && usertype === UserTypeEnum.USER
                  "
                >
                </app-access-control-card-list>
              </div>
            </div>
          </div>
          <div class="notice" *ngIf="!model && !editing">
            <p>
              <small
                >The electronic guardian will be sending an email to the
                information designee explaining their role.</small
              >
            </p>
          </div>
          <div class="input-container uk-text-center">
            <button
              class="uk-button uk-button-primary uk-button-thin savebutton"
              type="submit"
              *ngIf="(editing && !saving) || addModal"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
